import axios from 'axios'

export default axios.create({
  baseURL: 'http://18.179.104.139:8080/analyze_robot/'
})



// WEBPACK FOOTER //
// ./src/utils/request.js